import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import { dataService } from "../../Services/data.service";
import { TextField } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export default function SupplierType(props) {

  const [supplierTypes, setSupplierTypes] = useState([])
  const [supplierType, setSupplierType] = useState(null)

  const classes = useStyles();

  useEffect(() => {
    dataService.getSupplierTypes().then(types => {

      if (JSON.stringify(supplierTypes) !== JSON.stringify(types.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))) {
        setSupplierTypes(types.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))
      }

      if (props.chosenValue) {
        if (JSON.stringify(supplierType) !== JSON.stringify(types.Results.find(x => x.Name === props.chosenValue))) {
          setSupplierType(types.Results.find(x => x.Name === props.chosenValue))
        }
      }
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
  }, [])

  const setNextStep = () => {
    validate();
  }

  const validate = () => {
    if (supplierType) {
      props.SetNext();
      props.setContent(supplierType.ID, supplierType.Name);
    } else {
      toast.error("Pick a supplier type", { position: toast.POSITION.TOP_CENTER })
    }
  }

  const onChangeItem = (e) => {
    setSupplierType(supplierTypes.find(x => x.ID === e.target.value))
  } 

  return (
    <div className={classes.supplierTypeContainer}>

      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select2"
        className={classes.typeOfContractPicker}
        value={supplierType && supplierType.ID}
        onChange={(e) => onChangeItem(e)}
      >
        {supplierTypes.map(x => {
          return (
            <MenuItem value={x.ID}>{x.Name}</MenuItem>)
        })}

      </Select>
      <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>

    </div>
  )
}


const useStyles = makeStyles({
  container: {
    flexDirection: "row"
  },
  filterField: {
    width: "80%",
    flex: 1,
    justifyContent: 'center'
  },
  buttonContainer: {
    width: "15%",
    flex: 1,
    justifyContent: 'center'
  },
  typeOfContractPicker: {
    height: 44,
    backgroundColor: 'white',
    borderWidth: 1,
    marginBottom: 10,
    width: "100%"
  },
  supplierTypeContainer: {
    marginTop: "30px"
  },
  uiTextField: {
    width: "95%",
    backgroundColor: "white"
  },
});